import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import LazyDynamicPage from '../components/LazyDynamicPage'
import Page404 from '../views/errors/Page404'
import Page403 from '../views/errors/Page403'
import Page500 from '../views/errors/Page500'

Vue.use(Router);

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    alias: '/popups/'
  },
  {
    path: '/forbidden',
    name: 'Page403',
    alias: '/popups/Page403',
    props: false,
    component: Page403
  },
  {
    path: '/Page404',
    name: 'Page404',
    alias: '/popups/Page404',
    props: false,
    component: Page404
  },
  {
    path: '/Page500',
    name: 'Page500',
    alias: '/popups/Page500',
    props: false,
    component: Page500
  },
  {
    path: '/popups/:template',
    name: 'template',
    props: (route) => ({ name: route.query }),
    component: LazyDynamicPage,
    alias: '/:template'
  },
  {
    path: '*',
    props: false,
    component: Page404
  },
]



// WEBPACK FOOTER //
// ./src/router/routes.js